module.exports = __webpack_public_path__ + "static/img/xl1.dba29ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xl1.jpg
// module id = K0Xv
// module chunks = 1